'use strict';

function Controller() {
	let $ctrl = this;

	$ctrl.getDiffMarker = function () {
		if ($ctrl.diffReport.pendingDiff) {
			return 'pending';
		} else if ($ctrl.diffReport.hasDiff) {
			return 'warning';
		} else {
			return 'ok';
		}
	};
}

Controller.$inject = [
	'$stateParams',
	'$http',
	'$timeout',
	'$rootScope',
	'auth',
	'pmtSiteInfoService',
	'$i18next'
];

angular.module('pmtPlacesApp.controllers').component('pmtNetworkImageRow', {
	templateUrl: 'components/networks/facebook/pmtNetworkImageRow.html',
	controller: Controller,
	bindings: {
		imageType: '@',
		diffReport: '<',
		media: '<',
		networkImageUrl: '<',
		isEditing: '=',
		locationUsageCounts: '<',
		showImagePreview: '<',
		useNetworkImage: '<',
		showDeviationsDialog: '<',
		title: '@',
		isBrandPageImageSet: '<'
	}
});
